import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import PanelStatsApi from '../api/panel/panel_stats.ts';

export const fetchPanelStatsAsync = createAsyncThunk(
    'panelStats/fetchPanelStats',
    async (office_id) => {
        const response = await PanelStatsApi(office_id);
        return response;
    }
);

const panelStatsSlice = createSlice({
    name: 'panelStats',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPanelStatsAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPanelStatsAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchPanelStatsAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default panelStatsSlice.reducer;
